var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"height":"100vh"},attrs:{"src":"https://www.jmi-cloud.com/index.html","frameborder":"0","width":"100%","height":"100%"}})])
}]

export { render, staticRenderFns }